import { render, staticRenderFns } from "./ITSaleLargeAssets.vue?vue&type=template&id=287ed8df&scoped=true"
import script from "./ITSaleLargeAssets.vue?vue&type=script&lang=js"
export * from "./ITSaleLargeAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287ed8df",
  null
  
)

export default component.exports